// Keyboard shortcuts reference: account menu → Keyboard shortcuts, or press ? anywhere.
import { Modal } from '@/components/ui/Modal';
import { useUi } from '@/lib/ui';

const MOD = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform) ? '⌘' : 'Ctrl';

const GROUPS: { title: string; items: [string, string][] }[] = [
  {
    title: 'General',
    items: [
      ['Search or run a command', `${MOD} K`],
      ['Search', '/'],
      ['New task', 'T'],
      ['Show or hide the sidebar', '['],
      ['Keyboard shortcuts', '?'],
    ],
  },
  {
    title: 'Task window',
    items: [
      ['Previous task', 'K'],
      ['Next task', 'J'],
      ['Close', 'Esc'],
    ],
  },
  {
    title: 'Chat',
    items: [
      ['Find in channel', `${MOD} F`],
      ['Send message', 'Enter'],
      ['New line', 'Shift Enter'],
      ['Edit your last message', '↑'],
      ['Commands', '/'],
      ['Mention someone', '@'],
    ],
  },
  {
    title: 'Text',
    items: [
      ['Bold', `${MOD} B`],
      ['Italic', `${MOD} I`],
      ['Underline', `${MOD} U`],
    ],
  },
];

export function ShortcutsModal() {
  const open = useUi((s) => s.shortcutsOpen);
  return (
    <Modal open={open} onClose={() => useUi.setState({ shortcutsOpen: false })} title="Keyboard shortcuts" width={560}>
      <div className="shortcuts">
        {GROUPS.map((g) => (
          <section key={g.title} className="shortcuts-group">
            <h3 className="shortcuts-title">{g.title}</h3>
            {g.items.map(([label, keys]) => (
              <div key={label} className="shortcuts-row">
                <span className="grow">{label}</span>
                <span className="shortcuts-keys">
                  {keys.split(' ').map((k) => (
                    <kbd key={k}>{k}</kbd>
                  ))}
                </span>
              </div>
            ))}
          </section>
        ))}
      </div>
    </Modal>
  );
}
